import React, { Suspense, useMemo } from 'react';

import type { APMediaProps } from '../types';

interface APMediaFallbackProps {
  useMainDiv?: boolean;
  children: React.ReactNode;
}

export const APMediaFallback: React.FC<APMediaFallbackProps & APMediaProps> = ({
  type,
  style,
  size,
  rounded,
  aspectRatio,
  flip,
  rotate,
  rootClass,
  fullWidth = false,
  useMainDiv = true,
  children,
}) => {
  const transform = useMemo(() => {
    let result = '';
    if (flip !== undefined) {
      result += `scaleX(${flip === 'horizontal' || flip === 'both' ? -1 : 1}) scaleY(${
        flip === 'vertical' || flip === 'both' ? -1 : 1
      })`;
    }
    if (rotate !== undefined) {
      result += ` rotate(${rotate}deg) `;
    }
    return result;
  }, [flip, rotate]);

  const _aspectRatio = useMemo(() => {
    return aspectRatio;
  }, [aspectRatio]);

  const _size = useMemo(() => {
    if (size === undefined) {
      if (type === 'image') {
        return 24;
      }
    }
    return size;
  }, [size, type]);

  return (
    <Suspense
      fallback={
        <div
          style={{
            ...style,
            borderRadius: rounded ? '50%' : style?.borderRadius,
            display: 'flex',
            width: fullWidth ? '100%' : _size,
            aspectRatio: _aspectRatio,
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            transform: transform,
          }}
          className={rootClass}
        ></div>
      }
    >
      {useMainDiv ? (
        <div
          style={{
            ...style,
            borderRadius: rounded ? '50%' : style?.borderRadius,
            display: 'flex',
            width: fullWidth ? '100%' : _size,
            aspectRatio: _aspectRatio,
            alignItems: 'center',
            justifyContent: 'center',
            transform: transform,
          }}
          className={rootClass}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </Suspense>
  );
};

export default APMediaFallback;
